import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, { position: 'bottom-left', duration: 2000 })

const Toast = {
  install (Vue, options) {
    Vue.prototype.$toast = function (message, type, icon, close, durationTime) {
      if (!icon) {
        switch (type) {
          case 'info':
            icon = 'info-circle'
            break
          case 'error':
            icon = 'exclamation-triangle'
            break
          default :
            icon = 'info-circle'
            break
        }
      }

      var action
      if (close) {
        action = {
          icon: 'icon fal fa-times',
          iconPack: 'custom-class',

          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          }
        }
      }

      /* eslint no-unneeded-ternary: "error" */
      let options = {
        type,
        iconPack: 'custom-class',
        icon: {
          name: `icon fal fa-${icon}`
        },
        duration: durationTime ? durationTime : 2000,
        action
      }
      Vue.toasted.show(message, options)
    }
  }
}

export default Toast



// WEBPACK FOOTER //
// ./src/plugins/toast.js